import {PlanFeatureQuota} from "./plan-feature-quota.model";
import {PlanStatus} from "../enum/plan-status.enum";
import {PlanType} from "../enum/plan-type.enum";
import {PlanUser} from "../enum/plan-user.enum";
import {PlanPricingModel} from "./plan-pricing-model.model";
import {PlanVisibility} from "../enum/plan-visibility.enum";

export class Plan{
  _id?: string; // optional property for the plan ID if it already exists in the database
  name: string;
  planFeatureQuota: PlanFeatureQuota[];
  status: PlanStatus;
  type: PlanType;
  visibility: PlanVisibility;
  planUser: PlanUser;
  planPricingModels : PlanPricingModel[]
  constructor() {
  }
}
